import {Box} from "@mui/system";
import React from "react";
import _ from "lodash";
import {isValidPassword} from "_helpers";
import CharacterChecker from "./CharacterChecker";
import styles from "./Styles.module.css";

export default function PasswordStrengthIndicator({ value, isVisible, passwordStrength, meta: {touched, error, warning} }) {
  const isValidCharCount = passwordStrength.length >= 8;
  const isValidOptions = passwordStrength.contains.length >= 3;
  const hasError = touched && !_.isEmpty(error) && !isValidPassword(value);

  return(
    <Box className={ isVisible ? ( hasError ? styles.containerError : styles.container ) : styles.hide }>
      <Box className={ hasError ? styles.headerError : styles.header }>
        Your password must contain:
      </Box>
      <Box className={styles.checkerContainer}>
        <CharacterChecker
          label={'At least 8 characters'}
          isChecked={isValidCharCount}
          hasError={hasError} />
      </Box>
      <Box className={styles.checkerContainer}>
        <CharacterChecker
          label={'At least 3 of the following:'}
          isChecked={isValidOptions}
          hasError={hasError} />
      </Box>
      <Box sx={{margin: '8px 23px 0 23px'}}>
        <Box className={styles.checkerContainer}>
          <CharacterChecker
            label={'Lower case letters (a-z)'}
            isChecked={passwordStrength.contains.includes('lowercase')}
            hasError={hasError}/>
        </Box>
        <Box className={styles.checkerContainer}>
          <CharacterChecker
            label={'Upper case letters (A-Z)'}
            isChecked={passwordStrength.contains.includes('uppercase')}
            hasError={hasError} />
        </Box>
        <Box className={styles.checkerContainer}>
          <CharacterChecker
            label={'Numbers (0-9)'}
            isChecked={passwordStrength.contains.includes('number')}
            hasError={hasError} />
        </Box>
        <Box className={styles.checkerContainer}
             sx={{marginBottom: '0px !important'}}>
          <CharacterChecker
            label={'Special characters (ex. !@#$%^*)'}
            isChecked={passwordStrength.contains.includes('symbol')}
            hasError={hasError} />
        </Box>
      </Box>
    </Box>
  )
}